// Lenis Smooth Scroll Initialization
class LenisSmoothScroll {
  constructor() {
    this.lenis = null;
    this.init();
  }

  init() {
    // Wait for Lenis to be loaded
    if (typeof Lenis === 'undefined') {
      setTimeout(() => this.init(), 100);
      return;
    }

    // Initialize Lenis
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    // Animation frame loop
    const raf = (time) => {
      this.lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    // Integrate with existing scroll animations
    this.lenis.on('scroll', (e) => {
      // Trigger scroll events for existing animations
      window.dispatchEvent(new Event('scroll'));
    });

    // Handle anchor links
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const href = anchor.getAttribute('href');
        if (href === '#') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          this.lenis.scrollTo(target, {
            offset: -100, // Adjust for fixed headers
            duration: 1.5
          });
        }
      });
    });
  }

  // Public methods for external use
  scrollTo(target, options = {}) {
    if (this.lenis) {
      this.lenis.scrollTo(target, options);
    }
  }

  stop() {
    if (this.lenis) {
      this.lenis.stop();
    }
  }

  start() {
    if (this.lenis) {
      this.lenis.start();
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.lenisScroll = new LenisSmoothScroll();
  });
} else {
  window.lenisScroll = new LenisSmoothScroll();
}